import React from 'react';

import { FormattedMessage, useIntl } from 'react-intl';

import { ErrorMessage } from '@atlaskit/form/error-message';
import { Label } from '@atlaskit/form/label/default';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Flex, xcss } from '@atlaskit/primitives';
import Textfield from '@atlaskit/textfield/text-field';

import { messages } from './messages';

const errorStyles = xcss({
	paddingTop: 'space.050',
	gap: 'space.050',
	height: '16px',
});

type DisplayTextFieldProps = {
	displayText: string;
	handleOnChange: React.ChangeEventHandler<HTMLInputElement>;
	isInvalid: boolean;
	itemId: string;
};

export const DisplayTextField: React.FC<DisplayTextFieldProps> = ({
	itemId,
	displayText,
	handleOnChange,
	isInvalid,
}) => {
	const { formatMessage } = useIntl();

	return (
		<>
			<Label htmlFor={itemId}>{formatMessage(messages.displayTextLabel)}</Label>
			<Textfield
				value={displayText}
				onChange={handleOnChange}
				placeholder={formatMessage(messages.displayTextPlaceholder)}
				isInvalid={isInvalid}
				// link picker will still be able to insert a title longer than this
				// and there's no error messaging, but user will stop being able to
				// input more text after 100 chars
				maxLength={100}
			/>
			{isInvalid && (
				<Flex xcss={errorStyles}>
					<ErrorMessage>
						<FormattedMessage {...messages.displayTextError} />
					</ErrorMessage>
				</Flex>
			)}
		</>
	);
};
